import {Record} from 'immutable';
import {handleActions} from 'redux-actions';
import moment from 'moment-timezone';

import * as Actions from './actions';

const State = Record({
    activeDate: null,
    showReject: false,
    showOverridePrices: false,
    isVisible: false,
    childId: '',
    editItemId: '',
    ordering: undefined,
    deleting: false,
    loading: false,
});

const close = state =>
    state.merge({
        isVisible: false,
    });

export default handleActions(
    {
        [Actions.showPurchaseModal.type]: (state, {payload}) => {
            return new State({
                activeDate: moment(),
                isVisible: true,
                childId: payload.childId,
                editItemId: payload.itemId,
                ordering: payload.ordering,
            });
        },
        [Actions.showReject.type]: (state, {payload}) => {
            return state.merge({
                showReject: payload.show,
            });
        },
        [Actions.showOverridePrices.type]: (state, {payload}) => {
            return state.merge({
                showOverridePrices: payload.show,
            });
        },
        [Actions.onDateChange.type]: (state, {payload}) => {
            return state.merge({
                activeDate: payload.newDate,
            });
        },
        [Actions.hidePurchaseModal.type]: close,
        [Actions.hidePurchaseModalAfterUpdate.type]: close,
        [Actions.hidePurchaseModalAfterDelete.type]: close,
    },
    new State(),
);
